import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./graves.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./graves.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { TableSearchComponent } from "../../shared/components/table-search/table-search.component";
import { PropertySearchEnum } from "../properties/shared/models/property-search-model";
import { PropertyHeadingEnum, PropertySearchOption } from "../properties/shared/models/property-heading.model";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { BehaviorSubject } from "rxjs";
import { MapServiceService } from "../../core/settings/shared/map-service.service";
import { AppControllerService } from "../../app-controller.service";
import { RequestStatusService } from "../../shared/services/request-status/request-status.service";
import { SearchTableService } from "../../shared/services/table-column-mapping/search-table.service";
import { AflaModuleStrategyService, SearchContainerHeight } from "../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SaveSearchService } from "../../shared/services/save-search/save-search.service";
import { ModuleConfigService } from "../../shared/services/module-config/module-config.service";
import { headingToCemeteryGraveAttributeLookup, } from "../properties/shared/models/heading-to-property-attribute.model";
import { ArcGisPropertyColumn } from "../properties/shared/models/arcgis-property-column.model";
import { ModuleConfig } from "../../shared/models/module-config.model";
import _ from "underscore";
import { LocationsSearchColumnToArcGisColumnGraveLookup, PropertiesSearchColumnToArcGisColumnSectionalTitleLookup } from "../properties/shared/models/property-search-to-arcgis.model";
import { PropertiesConstants } from "../properties/properties.constants";
import { GravesConstants } from "./graves.constants";
import { GraveSearchService } from "./shared/services/grave-search.service";
import { GraveSearchEnum } from "./shared/enums/graves/grave-search.enum";
import { GraveSearchOption } from "./shared/models/grave/grave-search-option.enum";
import { ArcGisGraveColumn } from "./shared/arcgis-grave-column";
import { AlertType } from "../../shared/models/alert";
import { AutoUnsub } from "../../shared/decorators/autounsub.decorator";
let GravesComponent = class GravesComponent {
    graveSearchService;
    mapService;
    appControllerService;
    changeDetectorRef;
    requestStatusService;
    searchTableService;
    moduleStrategyService;
    saveSearchService;
    moduleConfigService;
    tableSearchFilterComponent;
    propertiesPageHeading = "";
    pageHeading = "";
    showSearchButton = true;
    propertyAttributeToTableColumn;
    filterOptions;
    selectedPropertySubject = new BehaviorSubject(undefined);
    selectedProperty;
    placeHolder;
    searchPlaceHolder;
    graveSearchTableDataSource;
    isMapLoaded = false;
    parentComponent = "GravesComponent";
    showSelectCemetery = false;
    selectedCemetery = null;
    preSelected;
    mapComponent;
    gravesList = [];
    listenForSearchChangesSubscription;
    setMapLayerSubscription;
    mapLocationSubscription;
    constructor(graveSearchService, mapService, appControllerService, changeDetectorRef, requestStatusService, searchTableService, moduleStrategyService, saveSearchService, moduleConfigService) {
        this.graveSearchService = graveSearchService;
        this.mapService = mapService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.requestStatusService = requestStatusService;
        this.searchTableService = searchTableService;
        this.moduleStrategyService = moduleStrategyService;
        this.saveSearchService = saveSearchService;
        this.moduleConfigService = moduleConfigService;
    }
    ngOnInit() {
        this.initializeConstants();
        this.finaliseMapSettings();
    }
    ngOnDestroy() {
        this.placeHolder = SharedConstants.SEARCH_BY_DEFAULT;
        this.gravesList = [];
        this.graveSearchTableDataSource = null;
        this.saveSearchService.clearSavedSearchResults();
        this.graveSearchService.clearGraveList();
        this.changeDetectorRef.detectChanges();
    }
    initializeConstants() {
        this.initializePageHeader();
        this.initializeSearchTableConstants();
        this.graveSearchService.clearGraveList();
        this.changeDetectorRef.detectChanges();
    }
    ngAfterViewInit() {
        this.listenForSelectedPropertyChange();
        this.listenForSearchChanges();
    }
    listenForSearchChanges() {
        this.listenForSearchChangesSubscription = this.graveSearchService.gravesListAsObservable.subscribe((graves) => {
            this.gravesList = graves;
        });
    }
    mapLoaded() {
        this.isMapLoaded = true;
    }
    setHeadings() {
        this.showSelectCemetery = this.moduleConfigService.isCemeteryModule();
        switch (this.graveSearchService.searchType) {
            case GraveSearchOption.Grave:
                this.propertyAttributeToTableColumn = headingToCemeteryGraveAttributeLookup;
                break;
        }
        this.graveSearchService.setTableColumnMap(this.propertyAttributeToTableColumn);
        this.setFilterOptions();
        this.changeDetectorRef.detectChanges();
    }
    async handleSimpleSearch(search) {
        await this.searchProperties(search);
    }
    handleCemeteryChange($event) {
        this.selectedCemetery = $event;
    }
    handleAdvancedSearch($event) {
        this.setHeadings();
        this.graveSearchTableDataSource = $event;
        this.changeDetectorRef.detectChanges();
    }
    async searchProperties(search) {
        if (search.column !== SharedConstants.SEARCH_BY_DEFAULT) {
            this.gravesList = [];
            this.graveSearchService.setGraveList(this.gravesList);
            // @ts-ignore
            const column = this.getArcGISColumn(search.column);
            const url = this.graveSearchService.getLayerUrl(this.graveSearchService.searchType);
            // @ts-ignore
            this.graveSearchTableDataSource = await this.doPropertySearch(url, search.text, column);
            this.changeDetectorRef.detectChanges();
        }
    }
    async doPropertySearch(url, searchText, column) {
        this.requestStatusService.showBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        // @ts-ignore
        try {
            // @ts-ignore
            if (column === "GraveID" || column === "Capacity" || column == "MarkerType") {
                // @ts-ignore
                await this.graveSearchService.doSearchWithAdditionalColumns(url, searchText, column, false, this.selectedCemetery ? this.selectedCemetery.toString() : null, ArcGisGraveColumn.CemeteryID)
                    .then((gravesFound) => {
                    // @ts-ignore
                    if (gravesFound.length > 0) {
                        this.graveSearchService.addGraveLocatorLink(gravesFound);
                    }
                    else {
                        this.appControllerService.showMessage(`${SharedConstants.NO_ITEMS_AVAILABLE_MESSAGE} that matches your search term`, AlertType.Warning);
                    }
                    this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
                });
            }
            else {
                // @ts-ignore
                await this.graveSearchService.doSearchWithAdditionalColumn(url, searchText, column, false, this.selectedCemetery ? this.selectedCemetery.toString() : null, ArcGisGraveColumn.CemeteryID)
                    .then((gravesFound) => {
                    // @ts-ignore
                    if (gravesFound.length > 0) {
                        this.graveSearchService.addGraveLocatorLink(gravesFound);
                    }
                    else {
                        this.appControllerService.showMessage(`${SharedConstants.NO_ITEMS_AVAILABLE_MESSAGE} that matches your search term`, AlertType.Warning);
                    }
                    this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
                });
            }
        }
        catch (e) {
            this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        }
    }
    setMapLayer() {
        this.setMapLayerSubscription = this.mapService.layerUrlListAsObservable.subscribe((layers) => {
            if (layers) {
                this.graveSearchService.clearURLList();
                layers.forEach((layer) => {
                    if (layer.moduleId === Number(this.appControllerService.selectedModuleID))
                        this.graveSearchService.setURL(layer.layerType, layer.url);
                });
                this.setPropertySearchOptions();
            }
        });
    }
    propertySelected($event) {
        this.selectedPropertySubject.next($event);
    }
    exportTableClicked($event) {
        this.selectedPropertySubject.next($event);
    }
    showMap(show) {
        const divMapForProperties = document.getElementById("divMapForProperties");
        if (divMapForProperties) {
            if (show) {
                this.searchTableService.changeContainerHeight(this.moduleStrategyService.name === ModuleConfig.Cemetery ? SearchContainerHeight.GraveLocationMap : SearchContainerHeight.PropertiesMap);
                this.changeDetectorRef.detectChanges();
                divMapForProperties.setAttribute("style", "display:block;");
            }
            else {
                this.searchTableService.changeContainerHeight(this.moduleStrategyService.name === ModuleConfig.Cemetery ? SearchContainerHeight.CemeteryLocationWithoutMap : SearchContainerHeight.PropertiesWithoutMap);
                this.changeDetectorRef.detectChanges();
                divMapForProperties.setAttribute("style", "display: none !important;");
            }
            this.changeDetectorRef.detectChanges();
        }
    }
    finaliseMapSettings() {
        this.searchPlaceHolder = `${SharedConstants.SEARCH_PREFIX} ${this.pageHeading.toLocaleLowerCase()}`;
        this.setMapLayer();
        this.showMap(false);
    }
    setPropertySearchOptions() {
        const searchOptionList = [];
        if (this.moduleConfigService.isCemeteryModule() && this.graveSearchService.graveUrl && this.graveSearchService.graveUrl !== "") {
            searchOptionList.push(..._.values(GraveSearchEnum));
        }
        const propertyOptions = [];
        searchOptionList.forEach((option) => {
            if (propertyOptions.indexOf(option) < 0
                && option !== PropertyHeadingEnum.Cemetery) {
                propertyOptions.push(option);
            }
        });
        this.searchTableService.setPropertySearchOptions(propertyOptions);
        this.graveSearchService.setSearchOptionLookup(GraveSearchEnum);
        this.preSelected = this.moduleConfigService.isCemeteryModule() ? propertyOptions[0] : PropertySearchEnum.ErfNumber;
        this.graveSearchService.setSelectedSearchOption(this.preSelected);
        this.searchTableService.setPreSelectedSearchOption(this.preSelected);
        this.selectedProperty = this.selectedPropertySubject.asObservable();
        this.setHeadings();
    }
    setFilterOptions() {
        this.filterOptions = new Array();
        this.filterOptions.push(SharedConstants.FILTER_BY_DEFAULT);
        this.filterOptions.push(..._.values(this.propertyAttributeToTableColumn.values()));
        this.changeDetectorRef.detectChanges();
    }
    getArcGISColumn(column) {
        this.graveSearchService.setSelectedSearchOption(column);
        this.setHeadings();
        switch (this.graveSearchService.searchType) {
            case GraveSearchOption.Grave:
                return LocationsSearchColumnToArcGisColumnGraveLookup.get(column);
            case PropertySearchOption.SectionalTitle:
                return PropertiesSearchColumnToArcGisColumnSectionalTitleLookup.get(column);
        }
    }
    listenForSelectedPropertyChange() {
        this.mapLocationSubscription = this.graveSearchService.mapLocationAsObservable.subscribe((selectedPropertyId) => {
            if (selectedPropertyId && selectedPropertyId !== "") {
                if (this.graveSearchService.searchType === GraveSearchOption.Grave)
                    this.viewSelectedGraveOnMap(selectedPropertyId);
                else
                    this.viewSelectedPropertyOnMap(selectedPropertyId);
            }
        });
    }
    viewSelectedGraveOnMap(id) {
        const url = this.graveSearchService.getLayerUrl(GraveSearchOption.Grave);
        this.requestStatusService.showBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        // @ts-ignore
        this.graveSearchService.doSearch(url, id, ArcGisGraveColumn.GraveObjectID, true, PropertySearchOption.Grave, true, true).then((result) => {
            if (result.length > 0) {
                this.setMapRoute(result);
            }
            this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        });
    }
    viewSelectedPropertyOnMap(propertyId) {
        const url = this.graveSearchService.getLayerUrl(PropertySearchOption.Property);
        this.requestStatusService.showBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        // @ts-ignore
        this.graveSearchService.doSearch(url, propertyId, ArcGisPropertyColumn.Id, true, SharedConstants.SEARCH_BY_DEFAULT, true).then((result) => {
            if (result.length > 0) {
                this.setMapRoute(result);
            }
            this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        });
    }
    setMapRoute(properties) {
        if (this.isMapLoaded) {
            this.showMap(true);
            this.mapComponent.removeGraphicsFromMap(PropertiesConstants.SELECTED_PROPERTY_GRAPHICS_LAYER);
            const geometries = [];
            properties.forEach((property) => {
                geometries.push(property.geometry);
            });
            this.mapComponent.addGeometriesOnMap(geometries, PropertiesConstants.SELECTED_PROPERTY_GRAPHICS_LAYER);
            this.changeDetectorRef.detectChanges();
        }
    }
    initializePageHeader() {
        this.pageHeading = GravesConstants.pageHeader;
    }
    initializeSearchTableConstants() {
        this.placeHolder = SharedConstants.SEARCH_BY_DEFAULT;
        this.gravesList = [];
        this.graveSearchService.clearGraveList();
        this.graveSearchTableDataSource = null;
        this.saveSearchService.clearSavedSearchResults();
        this.searchTableService.changeContainerHeight(SearchContainerHeight.CemeteryLocationWithoutMap);
        this.propertyAttributeToTableColumn = headingToCemeteryGraveAttributeLookup;
    }
    static ctorParameters = () => [
        { type: GraveSearchService },
        { type: MapServiceService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RequestStatusService },
        { type: SearchTableService },
        { type: AflaModuleStrategyService },
        { type: SaveSearchService },
        { type: ModuleConfigService }
    ];
    static propDecorators = {
        tableSearchFilterComponent: [{ type: ViewChild, args: [TableSearchComponent,] }],
        mapComponent: [{ type: ViewChild, args: ["esripropertiesmap", { static: true },] }]
    };
};
GravesComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-graves",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], GravesComponent);
export { GravesComponent };
